<template>
  <app-page>
    <template #main>
      <el-row :gutter="10" class="main">
        <el-col :span="24" class="title">待审核({{receiptTotal}})</el-col>
        <template v-for="(col, index) in colData">
          <el-col v-bind="colSpan" :key="index" :class="[col.show() ? 'pointer' : 'pointer-text']">
            <div class="content" @click="col.click ? col.click() : null">
              <div class="c-header">
                <div class="c-title">
                  <span>{{col.title}}</span>
                  <div v-if="col.titleTip" class="title-tip">{{col.titleTip}}</div>
                </div>
                <icon-svg name="icon-arrow-right" v-if="col.show()" />
              </div>
              <div class="c-value">{{col.value}}</div>
            </div>
          </el-col>
        </template>
      </el-row>
      <el-row :gutter="10" class="main order-box">
        <el-col :span="24" class="title">待办订单({{paymentTotal}})</el-col>
        <template v-for="(col, index) in orderColData">
          <el-col v-bind="colSpan" :key="index" :class="[col.show() ? 'pointer' : 'pointer-text']">
            <div class="content" @click="col.click ? col.click() : null">
              <div class="c-header">
                <div class="c-title">
                  <span>{{col.title}}</span>
                  <div v-if="col.titleTip" class="title-tip">{{col.titleTip}}</div>
                </div>
                <icon-svg name="icon-arrow-right" v-if="col.show()" />
              </div>
              <div class="c-value">{{col.value}}</div>
            </div>
          </el-col>
        </template>
      </el-row>
    </template>
  </app-page>
</template>

<script>
import { getFinReceiptWorkBenchCount, getFinPaymentWorkBenchCount } from '@/api/home';

export default {
  name: 'Home',
  data() {
    return {
      colSpan: {
        xs: 8,
        sm: 8,
        md: 8,
        lg: 6,
        xl: 6,
      },
      receiptData: {},
      paymentData: {},
    };
  },
  computed: {
    colData() {
      return [
        {
          title: '付款',
          value: this.paymentData.waitAuditPaymentCount ?? 0,
          show: () => this.$has('GZT-DSHFK'),
          click: () => {
            this.goToView('GZT-DSHFK', 'ReceivablesPaymentApplyList', {
              approvalStatus: '1',
            });
          },
        },
        {
          title: '付款退款',
          value: this.paymentData.waitAuditPayableRefundCount ?? 0,
          show: () => this.$has('GZT-DSHFKTK'),
          click: () => {
            this.goToView('GZT-DSHFKTK', 'ReceivablesPaymentRefund', {
              approvalStatus: '1',
            });
          },
        },
        {
          title: '收款退款',
          value: this.receiptData.waitAuditReceiveRefundCount ?? 0,
          show: () => this.$has('GZT-DSHSKTK'),
          click: () => {
            this.goToView('GZT-DSHSKTK', 'ReceivablesRefundList', {
              approvalStatus: '1',
            });
          },
        },
        {
          title: '取消订单',
          value: this.receiptData.waitAuditCancelOrderCount ?? 0,
          show: () => this.$has('GZT-DSHQXDD'),
          click: () => {
            this.goToView('GZT-DSHQXDD', 'CancelModifyOrderList', {
              applyType: '1',
              status: '1',
            });
          },
        },
        {
          title: '修改订单',
          value: this.receiptData.waitAuditModifyOrderCount ?? 0,
          show: () => this.$has('GZT-DSHXGDD'),
          click: () => {
            this.goToView('GZT-DSHXGDD', 'CancelModifyOrderList', {
              applyType: '2',
              status: '1',
            });
          },
        },
        {
          title: '分账',
          value: this.receiptData.waitAuditDivideCount ?? 0,
          show: () => this.$has('GZT-DSHFZ'),
          click: () => {
            this.goToView('GZT-DSHFZ', 'ReceivablesSubAccountList', {
              approvalStatus: '1',
            });
          },
        },
      ];
    },
    orderColData() {
      return [
        {
          title: '收款单',
          titleTip: '待确认',
          value: this.receiptData.waitConfirmReceiptCount ?? 0,
          show: () => this.$has('GZT-DQRSKD'),
          click: () => {
            this.goToView('GZT-DQRSKD', 'ReceivablesNoReceiptList', {
              verifiedStatus: '1',
              isH: '0',
            });
          },
        },
        {
          title: '服务商收款单',
          titleTip: '待确认',
          value: this.receiptData.waitConfirmProviderReceiveCount ?? 0,
          show: () => this.$has('GZT-DQRSKDFWS'),
          click: () => {
            this.goToView('GZT-DQRSKDFWS', 'ReceivablesServiceReceiptList', {
              verifiedStatus: '1',
              isH: '0',
            });
          },
        },
        {
          title: '付款单',
          titleTip: '待付款',
          value: this.paymentData.waitPayPaymentCount ?? 0,
          show: () => this.$has('GZT-DFKFKD'),
          click: () => {
            this.goToView('GZT-DFKFKD', 'paymentList', {
              status: '1',
            });
          },
        },

      ];
    },
    // 待审核总数
    receiptTotal() {
      const { waitAuditPaymentCount, waitAuditPayableRefundCount } = this.paymentData;
      const { waitAuditReceiveRefundCount, waitAuditDivideCount, waitAuditCancelOrderCount, waitAuditModifyOrderCount } = this.receiptData;
      const ptatol = (waitAuditPaymentCount ?? 0) + (waitAuditPayableRefundCount ?? 0);
      const rtotal = (waitAuditReceiveRefundCount ?? 0) + (waitAuditDivideCount ?? 0) + (waitAuditCancelOrderCount ?? 0) + (waitAuditModifyOrderCount ?? 0);
      return ptatol + rtotal;
    },
    // 订单管理总数
    paymentTotal() {
      const { waitConfirmProviderReceiveCount, waitConfirmReceiptCount } = this.receiptData;
      const total = (waitConfirmReceiptCount ?? 0) + (waitConfirmProviderReceiveCount ?? 0) + (this.paymentData.waitPayPaymentCount ?? 0);
      return total;
    },
  },
  created() {
    this.init();
  },
  methods: {
    /**
     * 待审核收款统计
     * 待审核收款退款单:ReceiveRefund
     * 待审核取消订单:CancelOrder
     * 待审核修改订单:ModifyOrder
     * 待审核分账:Divide
     * 待确认收款单:Receipt
     * 收款单(服务商):ProviderReceive
     *
     * 待审核付款统计
     * 待审核付款单:Payment
     * 待审核付款退款单:PayableRefund
     * 待付款付款单:PayPayment
     */
    init() {
      const paymentWord = {
        'GZT-DFKFKD': 'PayPayment',
        'GZT-DSHFKTK': 'PayableRefund',
        'GZT-DSHFK': 'Payment',
      };
      const receiptWord = {
        'GZT-DQRSKD': 'Receipt',
        'GZT-DSHFZ': 'Divide',
        'GZT-DSHXGDD': 'ModifyOrder',
        'GZT-DSHQXDD': 'CancelOrder',
        'GZT-DSHSKTK': 'ReceiveRefund',
        'GZT-DQRSKDFWS': 'ProviderReceive',
      };
      const paymentList = [];
      Object.keys(paymentWord).forEach((key) => {
        if (this.$has(key)) {
          paymentList.push(paymentWord[key]);
        }
      });
      const receiptList = [];
      Object.keys(receiptWord).forEach((key) => {
        if (this.$has(key)) {
          receiptList.push(receiptWord[key]);
        }
      });
      if (receiptList.length) {
        this.getFinReceiptWorkBenchCount(receiptList);
      }
      if (paymentList.length) {
        this.getFinPaymentWorkBenchCount(paymentList);
      }
    },
    // 待审核收款统计
    async getFinReceiptWorkBenchCount(keys) {
      try {
        const res = await getFinReceiptWorkBenchCount({ countSearchKey: keys });
        this.receiptData = res.data || {};
      } catch (error) {
        console.log(error);
      }
    },
    // 待审核付款统计
    async getFinPaymentWorkBenchCount(keys) {
      try {
        const res = await getFinPaymentWorkBenchCount({ countSearchKey: keys });
        this.paymentData = res.data || {};
      } catch (error) {
        console.log(error);
      }
    },
    goToView(authKey, routerName, query) {
      if (this.$has(authKey)) {
        this.$router.push({
          name: routerName,
          query,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .page-main {
    background: transparent !important;
  }
  .icon-svg {
    color: #4d4f51;
  }
}
.pointer {
  cursor: pointer;
}
.pointer-text {
  cursor: text;
}
.el-col {
  .content {
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 4px;
    background: #f7f9fd;
  }
}

.main {
  background: #fff;
  padding: 24px 19px;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #272728;
    margin-bottom: 16px;
    line-height: 26px;
  }
  .c-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .c-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4d4f51;
      line-height: 20px;
      .title-tip {
        margin-left: 8px;
        background: #e6e9ee;
        border-radius: 4px;
        padding: 1px 8px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #828487;
        line-height: 18px;
      }
    }
  }
  .c-value {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #feb812;
    line-height: 26px;
    margin-top: 4px;
  }
}

.order-box {
  margin-top: 16px;
}
</style>
